function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "backgroundrect",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0,
  fill: "none",
  stroke: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "lupa-2",
  "data-name": "lupa",
  className: ""
}, /*#__PURE__*/React.createElement("g", {
  id: "elipse",
  fill: "none",
  stroke: "#000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 10.5,
  stroke: "none",
  id: "svg_3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 9,
  fill: "none",
  id: "svg_4"
})), /*#__PURE__*/React.createElement("line", {
  id: "linha",
  x2: 25.5,
  y2: 25.5,
  fill: "none",
  stroke: "#000",
  strokeWidth: 3,
  y1: 19.5,
  x1: 19.5
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _ref3, _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.4641c0cf.svg";
export { ForwardRef as ReactComponent };